const wholeNumberFormatter = new Intl.NumberFormat('en-GB', { maximumFractionDigits: 0 })

/** Round decimal wire amounts for display without losing large integer precision. */
export const formatAccruedAmount = (value: string | null | undefined): string => {
  if (value == null) return '—'
  const parts = /^([+-]?)(\d+)(?:\.(\d+))?$/.exec(value)
  if (!parts) return '—'
  const [, sign, integer, fraction = ''] = parts
  let rounded = BigInt(integer)
  if ((fraction[0] ?? '0') >= '5') rounded += 1n
  return wholeNumberFormatter.format(sign === '-' ? -rounded : rounded)
}
